import Http from './http'

export default {
  async reloadPermits() {
    return Http.post('/api/sys/reload-permits')
  },
}




// WEBPACK FOOTER //
// ./src/api/sys.js